export default () => '/tickets';
